/**
 * Shared Slack OAuth error messages.
 *
 * Used by both the Slack settings section and the email & calendar section
 * (which shows Slack banners because it's the default OAuth redirect target).
 */

export const SLACK_ERROR_MESSAGES: Record<string, string> = {
  invalid_state: 'Authentication failed. Please try connecting again.',
  invalid_org: "You're not a member of this organization.",
  token_exchange_failed:
    "We couldn't complete Slack authentication. Try again.",
  incomplete_response:
    'Slack returned an incomplete response. Please try again.',
  workspace_already_connected:
    'This Slack workspace is already connected to another organization.',
  invalid_site_url: 'Server configuration error. Please contact the Ahoy team.',
  missing_code: 'No authorization code received from Slack. Please try again.',
  access_denied: 'You denied access to the Slack workspace.',
  invalid_client_id:
    'Invalid Slack app configuration. Please contact the Ahoy team.',
  invalid_redirect_uri:
    'Invalid redirect configuration. Please contact the Ahoy team.',
  invalid_scope: 'Invalid permissions requested. Please contact the Ahoy team.',
};

export const DEFAULT_SLACK_ERROR_MESSAGE =
  'An unexpected error occurred. Please try connecting again.';
